import React, { useState } from "react";
import { Input, Button, Form, Alert } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import flag from "../SignIn/TanzaniaFlag1.jpeg";
import emblem from "../SignIn/TanzaniaEmblem1.jpeg";
import "./styles.css";
import API from "../../../../API";
import { notifySuccess, notifyError } from "../../../../Util";

/**
 * @class
 * @name ResetPassword
 * @description Reset Password form component with actual API integration
 * @version 0.1.0
 * @since 0.1.0
 */
const ResetPassword = () => {
  const [sentPasswordLink, setSentPasswordLink] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");

  /**
   * @function
   * @name onFinish
   * @description handles form submission for password reset
   * @param {Object} values
   */
  const onFinish = async (values) => {
    setLoading(true);
    setError("");
    setEmail(values.email);

    try {
      await API.forgotPassword({ email: values.email });
      setSentPasswordLink(true);
      notifySuccess("Password reset instructions sent to your email");
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Failed to send reset instructions. Please try again.";
      setError(errorMessage);
      notifyError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  /**
   * @function
   * @name handleResendEmail
   * @description resends password reset email
   */
  const handleResendEmail = async () => {
    if (!email) return;
    
    setLoading(true);
    setError("");

    try {
      await API.forgotPassword({ email });
      notifySuccess("Password reset instructions resent to your email");
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Failed to resend email. Please try again.";
      setError(errorMessage);
      notifyError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // No activeMenuItem persistence.

  return (
    <div className="SignIn">
      <div className="SignInForm">
        <img src={flag} alt="Tanzanian flag" className="national-flag"></img>
        <div className="content-body">
          {!sentPasswordLink && (
            <img
              src={emblem}
              alt="Tanzanian national emblem"
              className="national-embelem"
            ></img>
          )}
          <div>
            {!sentPasswordLink && (
              <>
                <div className="Logo">
                  <h5>Forgot Password</h5>
                </div>
                <div style={{ textAlign: "center" }}>
                  <p>No worries, we'll send your reset instructions</p>
                </div>
                {error && (
                  <Alert
                    message={error}
                    type="error"
                    showIcon
                    style={{ marginBottom: '16px' }}
                    closable
                    onClose={() => setError('')}
                  />
                )}

                <Form autoComplete="off" onFinish={onFinish}>
                  {/* username field */}
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        required: true,
                        email: true,
                        message: "Please input your email!",
                      },
                    ]}
                  >
                    <Input
                      prefix={
                        <UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                      }
                      placeholder="Email"
                      data-testid="reset-password-email-input"
                    />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      data-testid="reset-password-submit-button"
                      className="signIn-form-button"
                      loading={loading}
                    >
                      Reset Password
                    </Button>
                  </Form.Item>
                  {/* end submit button */}
                </Form>
                <div style={{ display: "flex", justifyContent: "start" }}>
                  <Link to={{ pathname: `/signin` }}>Back to Log in</Link>{" "}
                </div>
              </>
            )}
            {sentPasswordLink && (
              <div>
                <div>
                  <h2>We've Sent Reset Password Instructions to Your Email</h2>
                  <p>
                    Please check the email inbox you signed up with. You may
                    need to check the Spam folder
                  </p>
                  {error && (
                    <Alert
                      message={error}
                      type="error"
                      showIcon
                      style={{ margin: '16px 0' }}
                      closable
                      onClose={() => setError('')}
                    />
                  )}
                </div>
                <div style={{ display: "flex", justifyContent: "end", marginBottom: "16px" }}>
                  <Button 
                    type="primary" 
                    loading={loading}
                    onClick={handleResendEmail}
                  >
                    Resend Email
                  </Button>
                </div>
                <div style={{ display: "flex", justifyContent: "start" }}>
                  <Link to={{ pathname: `/signin` }}>Back to log in</Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
